/*!
 * Copyright © 2018. Verizon Connect Ireland Limited. All rights reserved.
 */

export enum EEntityType {
  vehicle = 1,
  workOrder = 8
}
